import { Component, OnInit, ElementRef, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';

import { DashboardService } from '../../starter/service/dashboardservice';
import { HttpClient,HttpHeaders,HttpBackend  } from '@angular/common/http';
import { EnvService } from '../../core/env.service';
import { SearchFilterEmit } from '../../interfaces/SearchFilterEmit';
import { WebResService } from '../../webresolution/service/webresservices';
import { GlobalService } from '@global/global.service';

@Component({
  host: {
    '(document:click)': 'onClick($event)'
  },
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit, OnChanges {

  @Output() dataOut = new EventEmitter<SearchFilterEmit>();

  @Input() client: string;
  @Input() clear: boolean;
  @Input() appmodule: string;

  show: boolean = false;
  searchText: string;

  invoices: Array<any> = [];
  page: number = 1;

  selectedInvoices: any = {}
  invoiceShipmentValue: boolean = false;

  constructor(
    private _dashboardService: DashboardService,
    private _handler: HttpBackend,
    private elem: ElementRef,
    public _env: EnvService,
    private _webResService: WebResService,
    private globalS: GlobalService
  ) { 

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let property in changes) {
      if (property == 'clear' && !changes[property].firstChange && changes[property].currentValue != null) {
        this.searchText = '';
        this.invoices = []
      }
    }
  }

  onClick(event: Event) {
    if (!this.elem.nativeElement.contains(event.target))
        this.show = false;
  }

  search(){
    this.selectedInvoices = {};
    this.page = 1;
    if(this.appmodule == "Dashboard"){
      this._dashboardService.searchDashboard(this.searchText, this.page, this.client, this.invoiceShipmentValue)
        .subscribe(data => {
          this.invoices = data;
          this.show = true;
        });
      }else if(this.appmodule == "Webresolution"){
        this._webResService.GetWebResSearchInvoiceNo(this.searchText, this.page, this.client, this.invoiceShipmentValue)
        .subscribe(data => {
          this.invoices = data;
          this.show = true;
        });
      }
  }

  SELECTED_LENGTH(){
    return Object.keys(this.selectedInvoices).length;
  }

  ifSelected(data: any){
    if(data.Id in this.selectedInvoices){
      return true;
    }
    return false;
  }

  clearSelected(){
    this.selectedInvoices = { }
  }

  focus(){
    if(this.invoices.length > 0){
      this.show = true;
    }
  }

  selected(data: any){
    if(data.Id in this.selectedInvoices){
      delete this.selectedInvoices[data.Id];
    } else {
      this.selectedInvoices[data.Id] = data;
    }
  }

  view(){
    this.page++;  
    this._dashboardService.searchDashboard(this.searchText, this.page, this.client, this.invoiceShipmentValue)
        .subscribe(data => {
          this.invoices = data;
          this.show = true;
        });
  }

  prev(){
    this.page--;  
    this._dashboardService.searchDashboard(this.searchText, this.page, this.client, this.invoiceShipmentValue)
        .subscribe(data => {
          this.invoices = data;
          this.show = true;
        });
  }

  emitSelection(){
    if(!this.globalS.isEmptyObject(this.selectedInvoices)){
      let data: SearchFilterEmit = {
        list: this.selectedInvoices,
        searchText: this.searchText
      }  
      this.dataOut.emit(data);
      return;
    }
    this.globalS.createNotification('error','Error','No item selected!')
  }

}
